import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-admin-card-with-title',
    templateUrl: './admin-card-with-title.component.html',
    styleUrls: ['./admin-card-with-title.component.scss'],
    standalone: false
})
export class AdminCardWithTitleComponent {
  @Input() showToggleButton: boolean = false;
  @Input() cardTitle: string = '';
  @Input() isContentVisible: boolean = true;
  @Input() showUnderline: boolean = true;
  @Input() removeTopMargin: boolean = false;

  toggleCollapse(): void {
    this.isContentVisible = !this.isContentVisible;
  }
}
